/**
 * Push notification API client (R8.2).
 * Wraps calls to the R8.1 backend endpoints.
 */

import { http } from './http';
import type { PushPlatform } from '../platform/push';

export interface RegisterPushRequest {
  deviceId: string;
  platform: PushPlatform;
  pushToken: string;
}

export const pushApi = {
  /**
   * Register (or update) a device for push delivery.
   * Backend performs an upsert on (tenant_id, user_id, device_id).
   */
  async register(data: RegisterPushRequest): Promise<void> {
    await http.post('/push/register', data);
  },

  /**
   * Soft-delete a device registration (set is_active = false).
   * Called on logout or when the user disables push in settings.
   */
  async unregister(deviceId: string): Promise<void> {
    await http.post('/push/unregister', { deviceId });
  },
};
